import { createAsyncThunk } from '@reduxjs/toolkit';
import _ from 'lodash';

import { authApi } from 'src/api/auth';

import { setFormErrors, setRegisterEmail, setTwoFaData } from './auth.slice';

import { REACT_APP_TERMINAL_URL, ROUTE } from 'src/constants';

import i18n from 'src/i18n/i18n';

export const createUser = createAsyncThunk('auth/create-user', async (data, thunkApi) => {
  try {
    const { navigate, payload } = data;

    const response = await authApi.createUser(payload);

    console.log('createUser[response]', response);

    navigate(ROUTE.AUTH.SIGNUP_SUCESS?.replace(':language', i18n.language));

    thunkApi.dispatch(setRegisterEmail(payload.email));

    return response;
  } catch (error) {
    if (!_.isEmpty(error?.response?.data?.errors)) {
      thunkApi.dispatch(setFormErrors(error?.response?.data?.errors));
    }

    if (_.isEmpty(error?.response?.data?.errors)) {
      thunkApi.dispatch(setFormErrors({ email: error?.response?.data?.message }));
    }
  }
});

export const loginUser = createAsyncThunk('auth/login-user', async (data, thunkApi) => {
  try {
    const { payload } = data;

    const response = await authApi.loginUser(payload);

    window.location.replace(REACT_APP_TERMINAL_URL);

    return response;
  } catch (error) {
    if (!_.isEmpty(error?.response?.data?.errors)) {
      const code = error?.response?.data?.errors?.two_enabled;

      thunkApi.dispatch(setFormErrors({ ...error?.response?.data?.errors, code }));
    }

    if (_.isEmpty(error?.response?.data?.errors)) {
      thunkApi.dispatch(setFormErrors({ email: error?.response?.data?.message }));
    }

    if (error?.response?.data?.errors?.two_enabled) {
      const { navigate, payload } = data;

      thunkApi.dispatch(setTwoFaData(payload));

      navigate(ROUTE.AUTH.TWO_FA?.replace(':language', i18n.language));
    }
  }
});

export const forgotPassword = createAsyncThunk('auth/forgot-password', async (data, thunkApi) => {
  try {
    const { navigate, payload } = data;

    const response = await authApi.forgotPassword(payload);

    console.log('forgotPassword[response]', response);

    console.log('navigate', navigate);

    navigate(ROUTE.AUTH.FORGOT_PASSWORD_SUCCESS?.replace(':language', i18n.language));

    console.log('payload', payload);

    thunkApi.dispatch(setRegisterEmail(payload.email));

    console.log('here');

    return response;
  } catch (error) {
    if (!_.isEmpty(error?.response?.data?.errors)) {
      thunkApi.dispatch(setFormErrors(error?.response?.data?.errors));
    }

    if (_.isEmpty(error?.response?.data?.errors)) {
      thunkApi.dispatch(setFormErrors({ email: error?.response?.data?.message }));
    }
  }
});

export const resetPassword = createAsyncThunk('auth/reset-password', async (data, thunkApi) => {
  try {
    const { navigate, payload } = data;

    const response = await authApi.resetPassword(payload);

    console.log('resetPassword[response]', response);

    navigate(ROUTE.AUTH.SIGNIN?.replace(':language', i18n.language));

    return response;
  } catch (error) {
    if (!_.isEmpty(error?.response?.data?.errors)) {
      thunkApi.dispatch(setFormErrors(error?.response?.data?.errors));
    }

    if (_.isEmpty(error?.response?.data?.errors)) {
      thunkApi.dispatch(setFormErrors({ password: error?.response?.data?.message }));
    }
  }
});
